export const getBase64 = (file: any) => {
  return new Promise((resolve) => {
    let baseURL;
    // Make new FileReader
    const reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(file);

    // on reader load somthing...
    reader.onload = () => {
      // Make a fileInfo Object
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
};

export const getFileExtension = (name: string) => {
  return name.slice((Math.max(0, name.lastIndexOf(".")) || Infinity) + 1);
};
